import { Injectable } from '@angular/core';

export type LanguageCode = 'es-419' | 'es' | 'en' | 'pt' | 'fr' | 'de' | 'it' | 'mn';

export interface Language {
    name: string;
    code: LanguageCode;
    hi: string;
  }
  
  export const Languages: Language[] = [
    {
      name: 'Español latino',
      code: 'es-419',
      hi: '¡Hola!'
    },
    {
      name: 'Español',
      code: 'es',
      hi: '¡Hola!'
    },
    {
      name: 'English',
      code: 'en',
      hi: '¡Hi!'
    },
    {
      name: 'Português',
      code: 'pt',
      hi: '¡Olá!'
    },
    {
      name: 'Français',
      code: 'fr',
      hi: '¡Bonjour!'
    },
    {
      name: 'Deutsch',
      code: 'de',
      hi: '¡Hallo!'
    },
    {
      name: 'Italiano',
      code: 'it',
      hi: '¡Ciao!'
    },
    {
      name: 'Mongol',
      code: 'mn',
      hi: '¡Сайн уу!'
    }
  ];

@Injectable({
    providedIn: 'root'
})
export class SelectLanguageService {

    key = 'language';

    persist(language: LanguageCode): void {
        localStorage.setItem(this.key, language);
    }

    get(): LanguageCode {
        return localStorage.getItem(this.key) as LanguageCode;
    }

}
